import { render, staticRenderFns } from "./w-home-header.vue?vue&type=template&id=33804b9d&scoped=true&"
import script from "./w-home-header.vue?vue&type=script&lang=js&"
export * from "./w-home-header.vue?vue&type=script&lang=js&"
import style0 from "./w-home-header.vue?vue&type=style&index=0&id=33804b9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33804b9d",
  null
  
)

export default component.exports